import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=23a5206a&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=23a5206a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5206a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a5206a')) {
      api.createRecord('23a5206a', component.options)
    } else {
      api.reload('23a5206a', component.options)
    }
    module.hot.accept("./MessageDialog.vue?vue&type=template&id=23a5206a&scoped=true", function () {
      api.rerender('23a5206a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/MessageDialog.vue"
export default component.exports